import "./HumanitiesAndFigures.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import FeaturedArticle from "./sections/FeaturedArticle";
import NewsGrid from "./sections/NewsGrid";
import Sidebar from "./sections/Sidebar";
import Pagination from "./sections/Pagination";
import Footer from "@/reusable_sections/Footer";
export default function HumanitiesAndFiguresPage() {
  return <div>
      <Header />
      <HeroSection />
      <FeaturedArticle />
      <NewsGrid />
      <Sidebar />
      <Pagination />
      <Footer />
    </div>;
}